const style = {
  acknowledgementDialog: {
    width: 534,
    height: 668,
    // fontFamily: theme.font.regular,
    // color: theme.palette.grey[800],
    lineHeight: 1.4,
  },
  bold: {
    fontWeight: "600",
    // fontFamily: theme.font.medium,
  },
  bulkEditPaper: {
    width: 750,
  },
  filterDropdown: {
    // color: theme.palette.grey[600],
  },
  emailTag: {
    background: "#ffc617",
    width: "100%",
  },
  webhookTag: {
    background: "#ffa30a",
    width: "100%",
  },
  smsTag: {
    background: "#ffa30a",
    width: "100%",
  },
  glipTag: {
    background: "#f50",
    width: "100%",
  },
  statusColumn: {
    width: "54px",
    minWidth: "16px !important",
    // display: 'flex',
    // justifyContent: 'flex-end',
  },
  tagDisabled: {
    background: "grey.200",
  },
  switchLabel: {
    top: 1,
  },
  switchIcon: {
    marginTop: -1,
  },
  pageHeadingWrapper: {
    margin: "24px 0 40px 48px",
    position: "relative",
  },
  pageHeading: {
    color: "black",
    fontSize: 24,
    // fontFamily: "medium",
    fontWeight: 500,
    letterSpacing: 0.08,
  },
  pageHeadingCaption: {
    color: "grey.500",
    fontFamily: "regular",
    fontSize: 12,
    letterSpacing: 0.17,
  },
  actionWrapper: {
    display: "flex",
    alignItems: "center",
    padding: "8px 15px 24px 43px",
    borderBottom: `1px solid grey`,
  },
  actionButtonLeft: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    "& > .action": {
      marginRight: 34,
      position: "relative",
      fontSize: 13,
      // fontFamily: theme.font.regular,
    },
  },
  actionButtonRight: {
    display: "flex",
    alignItems: "center",
    // "& > .action": {
    //   marginLeft: "16px",
    // },
  },
  action: {
    marginLeft: 4,
  },
  pageHeadingMarker: {
    background: "#7f5bdb",
    height: 70,
    width: 4,
    position: "absolute",
    left: -24,
    top: 0,
  },
  textColor: {
    color: "#6258de",
    borderColor: "#6258de",
  },
  tablePaper: {
    "border-radius": "10px",
    "max-height": "600px !important",
  },
  disabled: {
    backgroundColor: "grey.100",
    color: "grey.500",
    cursor: "default",
    pointerEvents: "none",
  },
  bgColor: {
    backgroundColor: "rgb(237,246,255)",
  },
};
export default style;
